import React from 'react';

import { Box, BoxProps, Button, ButtonProps } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

type Props = ButtonProps & {
  children?: React.ReactNode;
  flex?: BoxProps['flex'];
};

const SquareButton: React.FC<Props> = ({ flex, children, href, ...buttonProps }) => {
  const { background } = useTheme();
  return (
    <Box
      variant="elevation_low"
      borderRadius="primary"
      minWidth={['311px', '343px', '462px']}
      display="flex"
      alignItems="center"
      alignContent="stretch"
      flex={flex}
    >
      <Button
        href={href}
        variant="flat"
        fullWidth
        justifyContent="left"
        size="large"
        sx={{
          border: 'none',
          padding: '20px',
          borderRadius: 'primary',
          height: '100%',
          textAlign: 'left',
          display: 'flex',
          alignItems: 'center',
          '&:hover': {
            background: background.info,
          },
        }}
        {...buttonProps}
      >
        {children}
      </Button>
    </Box>
  );
};
export default SquareButton;
